export enum TypeClass {
  Disease = 'disease',
  Support = 'support',
  Insurance = 'insurance',
}
